import type * as React from 'react';
import { EmptyState } from '@redhand/ui';
import { PageIntro, StateSection } from '../ui-helpers.js';

export function EmptyStatePage(): React.JSX.Element {
  return (
    <div>
      <PageIntro
        title="EmptyState"
        lead="Prázdný stav je součást návrhu každé obrazovky: říká, co tu bude, proč je to prázdné a co udělat teď. Konvence demo dat: prázdno ≠ chyba."
      />
      <StateSection title="Plný vzor: nadpis + popis + akce">
        <div className="rh-card">
          <EmptyState
            icon={<span>📂</span>}
            title="Zatím žádné případy"
            description="Až založíš první případ (nábor, prodej nebo pronájem), uvidíš ho tady včetně stavu a dalšího kroku."
            action={<button type="button" className="rh-btn rh-btn--primary">Založit první případ</button>}
          />
        </div>
      </StateSection>
      <StateSection title="Jen nadpis (minimální varianta)">
        <div className="rh-card">
          <EmptyState title="Žádné výsledky pro tento filtr" />
        </div>
      </StateSection>
      <StateSection title="Dlouhá čeština" description="Texty se lámou, karta drží tvar.">
        <div className="rh-card">
          <EmptyState
            title="Zatím tu nejsou žádné nemovitosti ze čtvrti Náměstí Přemysla Otakara II. v Českých Budějovicích"
            description="Jakmile se v této lokalitě objeví nábor, rezervace nebo prodej, přehled se naplní automaticky a uvidíš ho tady i v reportech pro vedení kanceláře."
          />
        </div>
      </StateSection>
    </div>
  );
}
